import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "Találja meg a legjobb fogorvost – FogPortál.hu országos kereső",
  description = "Fogászat kereső és fogorvos kereső országos lefedettséggel. Részletes adatok, szakterületek, nyitvatartás – minden, ami segít a választásban.",
  keywords = "fogorvos, fogászat, fogászati klinika, fogász, Budapest, Magyarország",
  ogImage = "/favicon.svg",
  ogType = "website",
  canonicalUrl,
  schema,
  noindex = false
}) => {
  const baseUrl = window.location.origin;
  const canonical = canonicalUrl || window.location.href;
  const fullOgImage = ogImage?.startsWith('http') ? ogImage : `${baseUrl}${ogImage}`;

  return (
    <Helmet>
      <html lang="hu" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="FogPortál.hu" />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="FogPortál.hu" />
      <meta property="og:locale" content="hu_HU" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
